import React, { Component } from "react";
import {
  Grid,
  Button,
  Typography,
  IconButton,
  InputAdornment,
  FormControl,
  Input,
  FormHelperText,
  InputLabel, Icon
} from "@material-ui/core";
import { Visibility, VisibilityOff } from "@material-ui/icons";
import { compose, graphql } from "react-apollo";
import { connect } from "react-redux";
import { LOGIN, SIGNUP } from "../../graphql/mutations/auth";
import style from "./style";
import { client } from "../../config/apollo";
import { GET_USER } from "../../graphql/queries/user";
import {
  setAuthToken,
  setUserId,
  setIsChef,
  setChefStep,
  clearLocalStorage, setForceChangePassword, setReturnUrl
} from "../../redux/auth";
import { emailRegex } from "../../config/constants";
import { GET_CHEF_DETAILS } from "../../graphql/queries/chef";
import { GoogleLogin } from "react-google-login";
import { gql } from 'apollo-boost';

const LOGIN_SOCIAL = gql`
  mutation($accessToken: String, $email: String, $deviceId: String, $deviceOS: String) {
    loginSocial(accessToken: $accessToken, email: $email, deviceId: $deviceId, deviceOS: $deviceOS) {
      accessToken
      id
      emailId
    }
  }
`;


class LoginForm extends Component {
  state = {
    email: "",
    password: "",
    passwordErr: false,
    emailErrMsg: "",
    emailErr: false,
    passwordErrMsg: "Use at least 8 characters with letters and numbers",
    loginErr: false,
    loginErrMsg: "",
    errors: false,
    loading: false,
    openSignUpDrawer: false,
    showPassword: false,
    notVerifiedError: false,
    returnUrl: ''
  };

  toggleShowPassword = () => {
    this.setState({ showPassword: !this.state.showPassword });
  };

  toggleSignUpDrawer = () => {
    this.setState({ openSignUpDrawer: !this.state.openSignUpDrawer });
  };

  handleInputChange = e => {
    const { name, value } = e.target;
    switch (name) {
      default:
        return;
      case "email":
        this.setState({ email: value });
        break;

      case "password":
        this.setState({ password: value });
        break;
    }
  };
  checkErrors = () => {
    let errors = false;
    this.setState({ loginErr: false, loginErrMsg: "" });
    const { email, password } = this.state;
    if (email.trim().length <= 0) {
      this.setState({
        errors: true,
        emailErr: true,
        emailErrMsg: "Email is required"
      });
      errors = true;
    } else if (!emailRegex.test(email.trim())) {
      this.setState({
        errors: true,
        emailErr: true,
        emailErrMsg: "Invalid Email"
      });
      errors = true;
    } else {
      this.setState({ errors: false, emailErr: false, emailErrMsg: "" });
      errors = false;
    }

    if (password.trim().length <= 7) {
      this.setState({ errors: true, passwordErr: true });
      errors = true;
    } else {
      this.setState({ errors: false, passwordErr: false });
      errors = false;
    }

    if (password.trim().length <= 0) {
      this.setState({
        errors: true,
        passwordErr: true,
        passwordErrMsg: "Password is required"
      });
      errors = true;
    } else {
      this.setState({
        errors: false,
        passwordErr: false,
        passwordErrMsg: "Use at least 8 characters with letters and numbers"
      });
      errors = false;
    }

    return errors;
  };

  handleBlur = e => {
    const {
      target: { name, value }
    } = e;
    if (name === "email") {
      if (value.trim().length <= 0) {
        this.setState({
          errors: true,
          emailErr: true,
          emailErrMsg: "Email is required"
        });
      } else if (!emailRegex.test(value.trim())) {
        this.setState({
          errors: true,
          emailErr: true,
          emailErrMsg: "Invalid Email"
        });
      } else {
        this.setState({ errors: false, emailErr: false, emailErrMsg: "" });
      }
    }

    if (name === "password") {
      if (value.trim().length <= 7) {
        this.setState({ errors: true, passwordErr: true });
      } else {
        this.setState({ errors: false, passwordErr: false });
      }

      if (value.trim().length <= 0) {
        this.setState({
          errors: true,
          passwordErr: true,
          passwordErrMsg: "Password is required"
        });
      } else {
        this.setState({
          errors: false,
          passwordErr: false,
          passwordErrMsg: "Use at least 8 characters with letters and numbers"
        });
      }
    }
  };

  handleLogin = async e => {
    const { dispatch } = this.props;
    e.preventDefault();

    clearLocalStorage();

    try {
      this.setState({ loading: true });
      if (this.checkErrors()) {
        this.setState({ loading: false });
        return;
      }

      if (this.state.errors) {
        this.setState({ loading: false });
        return;
      }

      if (this.state.email && this.state.password) {
        const resp = await this.props.login({
          variables: {
            id: this.state.email,
            pwd: this.state.password
          },

        });

        if (resp.data) {
          this.setState({ loading: false, email: "", password: "" });
          //const { dispatch } = this.props;
          const { dispatch } = this.props;

          dispatch(setUserId(resp.data.login));
          dispatch(setAuthToken(resp.authorization));

          const userData = await client.query({
            query: GET_USER,
            variables: {
              id: resp.data.login
            },
            fetchPolicy: 'no-cache'
          });
          if (userData) {
            if (userData.data) {
              const { user } = userData.data;

              if (user.forceChangePassword) {
                dispatch(setForceChangePassword(true));
              } else {
                dispatch(setForceChangePassword(false));
              }
              if (user.isChef) {
                const chefResp = await client.query({
                  query: GET_CHEF_DETAILS,
                  variables: {
                    id: user.id
                  }
                });
                if (chefResp) {
                  // this.props.toggleLoginDrawer();

                  if (chefResp.data) {
                    const chefData = chefResp.data.chef;
                    if (chefData.completedSetupStep) {

                      dispatch(setChefStep(parseInt(chefData.completedSetupStep)));
                    } else {
                      dispatch(setChefStep(1));
                    }
                  }
                }

                dispatch(setIsChef(true));
                if (this.props.returnUrl) {
                  this.props.history.push(this.props.returnUrl);
                  dispatch(setReturnUrl(null));
                } else {
                  this.props.history.push("/home/dashboard");
                }

              } else {
                if (this.props.returnUrl) {
                  this.props.history.push(this.props.returnUrl);
                  dispatch(setReturnUrl(null));
                } else {
                  this.props.history.push("/home/dashboard");
                }
              }
            }
          }
        }

        if (resp.errors) {
          const errMsg = resp.errors[0].message;
          if (errMsg === 'Email is not verified') {
            this.setState({
              loginErr: false,
              loginErrMsg: errMsg,
              loading: false,
              email: "",
              password: "",
              notVerifiedError: true
            });
          } else {
            this.setState({
              loginErr: true,
              loginErrMsg: errMsg,
              loading: false,
              email: "",
              password: "",
              notVerifiedError: false
            });
          }
        }
      }

    } catch (err) {
      let errorObj = JSON.parse(JSON.stringify(err));
      if (errorObj.graphQLErrors) {
        if (errorObj.graphQLErrors.length) {
          if (errorObj.graphQLErrors.length > 0) {
            const errMsg = errorObj.graphQLErrors[0].message;
            if (errMsg === 'Email is not verified') {
              this.setState({
                loginErr: false,
                loginErrMsg: errMsg,
                loading: false,
                email: "",
                password: "",
                notVerifiedError: true
              });
            } else {
              this.setState({
                loginErr: true,
                loginErrMsg: errMsg,
                loading: false,
                email: "",
                password: "",
                notVerifiedError: false
              });
            }
          }
        }
      }
    }
  };

  handleGoogleSuccess = async googleResp => {
    try {
      const resp = {...googleResp};
      const { accessToken, profileObj: { email, familyName, givenName, imageUrl } } = resp;
      const userProfile = {
        emailId: email,
        firstName: givenName,
        lastName: familyName,
        accessToken,
        pwd: accessToken
      };

      const loginPayload = {
        email,
        accessToken,
        deviceId: 'chrome',
        deviceOS: 'web'
      };

      const loginResp = await this.props.loginSocial({
        variables: loginPayload
      });

      if (loginResp.data && loginResp.data.loginSocial) {
        const resp = loginResp.data.loginSocial;
        if (resp.accessToken !== null) {
          //handle login response here here
          clearLocalStorage();
          this.setState({ loading: false, email: "", password: "" });
          const { dispatch } = this.props;
          dispatch(setUserId(resp.id));
          dispatch(setAuthToken(loginResp.authorization));

          const userData = await client.query({
            query: GET_USER,
            variables: {
              id: loginResp.data.loginSocial.id
            }
          });
          if (userData) {
            if (userData.data) {
              const { user } = userData.data;
              if (user.isChef) {
                dispatch(setIsChef(true));
                if (this.props.returnUrl) {
                  this.props.history.push(this.props.returnUrl);
                  dispatch(setReturnUrl(null));
                } else {
                  this.props.history.push("/home/dashboard");
                }

                const chefResp = await client.query({
                  query: GET_CHEF_DETAILS,
                  variables: {
                    id: user.id
                  }
                });
                if (chefResp) {
                  this.props.toggleLoginDrawer();
                  if (chefResp.data) {
                    const chefData = chefResp.data.chef;
                    if (chefData.completedSetupStep) {
                      dispatch(setChefStep(chefData.completedSetupStep));
                    } else {
                      dispatch(setChefStep(1));
                    }
                  }
                }
              } else {
                if (this.props.returnUrl) {
                  this.props.history.push(this.props.returnUrl);
                  this.props.dispatch(setReturnUrl(null));
                } else {
                  this.props.history.push("/home/dashboard");
                }
              }
            }
          }
        }
        else {
          const logResp = await this.props.loginSocial({
            variables: {accessToken: email}
          });

          if (logResp.data && logResp.data.loginSocial) {
            const resp = logResp.data.loginSocial;
            if (resp.accessToken !== null) {
              //handle login response here here
              clearLocalStorage();
              this.setState({loading: false, email: "", password: ""});
              const {dispatch} = this.props;
              dispatch(setUserId(resp));
              dispatch(setAuthToken(logResp.authorization));

              const userData = await client.query({
                query: GET_USER,
                variables: {
                  id: logResp.data.loginSocial
                }
              });
                  if (userData) {
                if (userData.data) {
                  const { user } = userData.data;
                  if (user.isChef) {
                    dispatch(setIsChef(true));

                    this.props.history.push("/home/chef-portfolio");

                    const chefResp = await client.query({
                      query: GET_CHEF_DETAILS,
                      variables: {
                        id: user.id
                      }
                    });
                    if (chefResp) {
                      this.props.toggleLoginDrawer();
                      if (chefResp.data) {
                        const chefData = chefResp.data.chef;
                        if (chefData.completedSetupStep) {
                          //console.log("FOUND STEP: ", chefData.completedSetupStep);
                          dispatch(setChefStep(chefData.completedSetupStep));
                        } else {
                          dispatch(setChefStep(1));
                        }
                      }
                    }
                  } else {
                    if (this.props.returnUrl) {
                      this.props.history.push(this.props.returnUrl);
                      this.props.dispatch(setReturnUrl(null));
                    } else {
                      this.props.history.push("/home/dashboard");
                    }
                  }
                }
              }
            }
            else {
              this.setState({
                loginErr: true,
                loginErrMsg: "Email Id not registered",
                loading: false,
                email: "",
                password: ""
              });
            }
          }
        }
      }
    }
    catch(error) {
      console.log('GOOGLE LOGIN ERR: ', error);
    }
  };

  handleGoogleFailure = async googleResp => {
    try {
      console.log('GOOGLE LOGIN FAILURE RESP: ', googleResp);
    }
    catch(error) {
      console.log('GOOGLE LOGIN FAILURE ERR: ', error);
    }
  };

  render() {
    return (
      <Grid container style={{ maxWidth: 420, width: '100%', marginTop: '7%' }}>
        <Grid container justify={'space-between'}>
          <div />
          <Button
          data-test-id={"createacc-id"}
            size="small"
            style={{ ...style.msg, ...style.setColor, float:'right' }}
            //onClick={this.toggleSignUpDrawer}
            onClick={() => this.props.history.push("/sign-up")}
          >
            Create an account
          </Button>
        </Grid>
        <Grid item xs={12} style={{ margin: "10px 0" }} />
        {this.state.loginErr && (
          <Grid item xs={12} style={style.errGrid}>
            <Typography component="p" style={style.errGridText}>
              {this.state.loginErrMsg}
            </Typography>
          </Grid>
        )}
        {
          this.state.notVerifiedError && (
            <Grid item xs={12} style={style.errGridSimple}>
              <Typography component="p" style={style.errGridTextSimple}>
                Please verify your email, before attempting to log in. A verification email was sent to the email id that you used for signing up.
                Once verified, you can come back to log in.
              </Typography>
            </Grid>
          )
        }
        <Grid container className="sidebar-custom-container">
          <Typography variant="h5" className="side-bar-heading">
            Sign in
          </Typography>
        </Grid>
        <Grid container>
          <form
            action="#!"
            method="post"
            style={{ width: "100%" }}
            onSubmit={e => this.handleLogin(e)}
          >
            <Grid item xs={12} style={style.inputCtrl}>
              <FormControl fullWidth={true}>
                <InputLabel
                  htmlFor="Email Address"
                  style={
                    this.state.emailErr
                      ? { ...style.setFont, ...style.error }
                      : style.setFont
                  }
                >
                  Email
                </InputLabel>
                <Input
                  error={this.state.emailErr}
                  inputProps={{ 'data-test-id': 'username' }}
                  style={{ ...style.setFont }}
                  onChange={this.handleInputChange}
                  onBlur={this.handleBlur}
                  name="email"
                  value={this.state.email}
                />
                <FormHelperText
                  style={
                    this.state.emailErr
                      ? { ...style.setFont, ...style.error }
                      : { ...style.setFont, ...style.msg }
                  }
                >
                  {this.state.emailErrMsg}
                </FormHelperText>
              </FormControl>
            </Grid>
            <Grid item xs={12} style={style.inputCtrl}>
              <FormControl fullWidth={true}>
                <InputLabel
                  htmlFor="Password"
                  style={
                    this.state.passwordErr
                      ? { ...style.setFont, ...style.error }
                      : style.setFont
                  }
                >
                  Password
                </InputLabel>
                <Input
                  error={this.state.passwordErr}
                  inputProps={{ 'data-test-id': 'password' }}
                  style={{ ...style.setFont }}
                  onChange={this.handleInputChange}
                  onBlur={this.handleBlur}
                  name="password"
                  type={this.state.showPassword ? "text" : "password"}
                  value={this.state.password}
                  endAdornment={
                    <InputAdornment position="end">
                      <IconButton
                      data-test-id={"togglepwd"}

                        aria-label="Toggle Password Visibility"
                        onClick={this.toggleShowPassword}
                      >
                        {this.state.showPassword ? (
                          <Visibility />
                        ) : (
                          <VisibilityOff />
                        )}
                      </IconButton>
                    </InputAdornment>
                  }
                />
                <FormHelperText
                  style={
                    this.state.passwordErr
                      ? { ...style.setFont, ...style.error }
                      : { ...style.setFont, ...style.msg }
                  }
                >
                  {this.state.passwordErrMsg}
                </FormHelperText>
              </FormControl>
            </Grid>
            <Grid  container justify="flex-end">
              <Button data-test-id={"forgotpassword"} size="small" style={style.msgForgot} onClick={() => this.props.history.push('/forgot-password')}>
                Forgot Password ?
              </Button>
            </Grid>

            <Grid
              item
              xs={12}
              style={{ ...style.inputCtrl, ...style.topSpace }}
            >
              <Button
                type="submit"
                variant="contained"
                disabled={this.state.loading}
                fullWidth={true}
                color="primary"
                style={style.btnLogin}
                data-test-id={"login-button"}
              >
                Sign in
              </Button>
            </Grid>

            <Grid
            data-test-id={"logingoogle-id"}

              item
              xs={12}
              style={{ ...style.inputCtrl, ...style.topSpace, alignItems: 'center', alignContent: 'center', paddingLeft: '25%'  }}
            >
              <GoogleLogin
                buttonText={"Sign in with Google"}
                onSuccess={this.handleGoogleSuccess}
                onFailure={this.handleGoogleFailure}
                clientId={"359174974921-najevtb0kk4jijdkt1tfdob9shdlvvtm.apps.googleusercontent.com"}
                scope={"profile email"}
              />
            </Grid>
          </form>
        </Grid>
      </Grid>
    );
  }
}

const mapSateToProps = state => {
  return {
    returnUrl: state.auth.returnUrl
  };
};
const LoginWithData = compose(
  graphql(LOGIN, { name: "login" }),
  graphql(LOGIN_SOCIAL, { name: "loginSocial" }),
  graphql(SIGNUP, { name: "createUser" })
)(LoginForm);

const Login = connect(mapSateToProps)(LoginWithData);

export default Login;
